import React from 'react';
import { footerColumns } from '../data/site';
export function SiteFooter() {
  return <footer className="w-full bg-navy text-white" data-id="element-176" data-mp="3r7punplj411c">
      <div className="mx-auto grid max-w-[1600px] grid-cols-2 gap-8 px-10 py-14 md:grid-cols-3 lg:grid-cols-6" data-id="element-177" data-mp="3r919ckgiit78">
        {footerColumns.map(col => <div key={col.title} data-id="element-178" data-mp="3hizmtx3t5iuf">
            <h2 className="text-2xl font-semibold" data-id="element-179" data-mp="3hhwwbqaedif1">{col.title}</h2>
            <ul className="mt-4 space-y-2 text-white/75" data-id="element-180" data-mp="3dhe3pu0ok8bs">
              {col.links.map(l => <li key={l} data-id="element-181" data-mp="38h8eekhvuxwv">{l}</li>)}
            </ul>
          </div>)}
      </div>
      <p className="border-t border-white/10 py-5 text-center text-sm text-white/60" data-id="element-182" data-mp="33hvkjfslgqks">© 2026 i9 Sports. All rights reserved.</p>
    </footer>;
}